const takeTime = [
  {time: '10:30 - 14:30', price: 0, title: 'PLM ☀️'},
  {time: '15:30 - 19:30', price: 0, title: 'PLT🌙'}]
export default takeTime 